import AboutJaaSection from '../../../components/Promotional/AboutJaaSection';
import {
  Typography,
  CssBaseline,
  ThemeProvider,
  Stack,
  Box,
  Skeleton,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { almaStyleArticleTheme } from '../../../ArticleTheme';
import Article from '../../../types/Article';
import { hasSubscriptionAccess } from '../../Authentication/utils/AuthUtilities';
import { TujuAccountInformation } from '@almamedia-legal-insights/types';

interface ArticlePreviewProps {
  article: Article;
  authInfo?: TujuAccountInformation;
  restrictionResolved: boolean;
  isRefetching: boolean;
}

export default function ArticlePreview({
  article,
  authInfo,
  restrictionResolved,
  isRefetching,
}: Readonly<ArticlePreviewProps>) {
  return (
    <>
      <Stack sx={{ marginBottom: 8 }}>
        <ThemeProvider theme={almaStyleArticleTheme}>
          <CssBaseline>
            <Typography variant='h1'>{article.meta.title}</Typography>

            {!restrictionResolved || isRefetching ? (
              <>
                {article.meta.description && (
                  <Typography sx={{ ...visuallyHidden }}>
                    {article.meta.description}
                  </Typography>
                )}
                <Box sx={{ mt: 4, mb: 2 }}>
                  <Stack spacing={1.5}>
                    <Skeleton variant='text' height={24} />
                    <Skeleton variant='text' height={24} />
                    <Skeleton variant='text' height={24} />
                    <Skeleton variant='text' height={24} />
                    <Skeleton variant='text' height={24} />
                  </Stack>
                </Box>
              </>
            ) : (
              article.meta.description && (
                <Typography variant='subtitle1' sx={{ whiteSpace: 'pre-wrap' }}>
                  {article.meta.description}
                </Typography>
              )
            )}
          </CssBaseline>
        </ThemeProvider>
      </Stack>

      {restrictionResolved &&
        !isRefetching &&
        !hasSubscriptionAccess(authInfo) && (
          <Stack direction='column' useFlexGap spacing={6}>
            <AboutJaaSection />
          </Stack>
        )}
    </>
  );
}
